<template>
    <div>

        <!-- JAHRES-TABS nur anzeigen, wenn es Jahre gibt -->
        <ul v-if="getYears.length > 0"
            class="nav nav-tabs"
            id="myTab"
            role="tablist">
            <li v-for="(year, index) in getYears"
                :key="year"
                class="nav-item"
                role="presentation">
                <button class="nav-link"
                    :class="index === 0 ? 'active' : ''"
                    :id="getYearButtonId(year)"
                    data-bs-toggle="tab"
                    :data-bs-target="getTarget(year)"
                    type="button"
                    role="tab"
                    :aria-controls="getTabId(year)"
                    :aria-selected="index === 0">
                    {{ year }}
                </button>
            </li>
        </ul>

        <!-- TAB CONTENT -->
        <div v-if="getYears.length > 0"
            class="tab-content"
            id="priceTabContent">
            <div v-for="(year, index) in getYears"
                :key="year"
                class="tab-pane fade"
                :class="index === 0 ? 'show active' : ''"
                :id="getTabId(year)"
                role="tabpanel"
                :aria-labelledby="getTabAreaLabel(year)">
                <table class="table pricelist-table table-hover">
                    <tbody v-for="sg in yearlyPrices"
                        :key="sg.service._id">

                        <!-- Unterzeilen je Preisperiode -->
                        <tr v-for="price in sg.lines"
                            :key="price.sourceId"
                            class="subrow"
                            v-if="isDateInRange(price.fromdate, price.tilldate, year)">
                            <td class="subinfo">
                                {{ getFormattedDate(price.fromdate) }} - {{ getFormattedDate(price.tilldate) }}
                                <br><small>{{ price.season }}</small>
                            </td>
                            <td class="text-end calc">
                                <span v-if="sg.service.calculation === 'FLAT'">{{ voMsg('tpl.service.FLAT') }}</span>
                                <span v-if="sg.service.calculation === 'NIGHT'">{{ voMsg('tpl.service.NIGHT') }}</span>
                                <span v-if="sg.service.calculation === 'WEEK'">{{ voMsg('tpl.service.WEEK') }}</span>
                                <span v-if="sg.service.calculation === 'MONTH'">{{ voMsg('tpl.service.MONTH') }}</span>
                                <span v-if="sg.service.calculation === 'USAGE'">{{ voMsg('tpl.service.USAGE') }}</span>
                            </td>
                            <td class="text-end price">
                                <span v-if="price.value">{{ getCalculatedPrice(price.value) }}</span>
                                <span v-if="sg.service.calculation === 'USAGE'">{{ voMsg('tpl.service.USAGE') }}</span>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>

        <!-- ZEITUNABHÄNGIGE PREISE -->
        <table v-if="hasGlobalPrices"
            class="table pricelist-table table-hover mb-3">
            <tbody v-for="sg in globalPrices"
                :key="sg.service._id">
                <tr>
                    <td>
                        {{ sg.service.name }}
                        <span v-if="!sg.service.mandatory">({{ voMsg('tpl.text.optional') }})</span>
                        <span v-if="sg.service.mandatory"><sup>*</sup></span>
                    </td>
                    <td class="text-end">
                        <span>{{ voMsg('tpl.service.' + sg.service.calculation) }}</span>
                    </td>
                    <td class="text-end price">
                        <span>{{ getCalculatedPrice(sg.price) }}</span>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="hint"><sup>*</sup>{{ voMsg('tpl.text.priceObligatory') }}</div>
    </div>
</template>

<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'seasonprices',
    	props: {
    		pricelist: String
    	},
    	data() {
    		return {
    			priceArray: [],
    		};
    	},
    	mounted: function() {
    		this.priceArray = JSON.parse(this.pricelist);
    		console.log('this.priceArray', JSON.stringify(this.priceArray, null, 2));
    	},
    	computed: {
    		// Alle Jahre aus zeitabhängigen Preisen
    		getYears: function() {
    			const years = new Set();
    			const currentYear = new Date().getFullYear();

    			this.yearlyPrices.forEach(group => {
    				group.lines.forEach(line => {
    					const start = new Date(line.fromdate).getFullYear();
    					const end = new Date(line.tilldate).getFullYear();
    					for (let y = start; y <= end; y++) {
    						if (y >= currentYear) { // nur aktuelle und zukünftige Jahre
    							years.add(String(y));
    						}
    					}
    				});
    			});

    			return Array.from(years).sort();
    		},
    		// Preise MIT lines (zeitabhängig)
    		yearlyPrices: function() {
    			return this.priceArray.filter(sg => sg.lines && sg.lines.length > 0);
    		},
    		// Preise OHNE lines (zeitunabhängig)
    		globalPrices: function() {
    			return this.priceArray.filter(sg => !sg.lines || sg.lines.length === 0);
    		},
    		hasGlobalPrices: function() {
    			return this.globalPrices.length > 0;
    		}
    	},
    	methods: {
    		getYearButtonId: function(year) {
    			return 't' + year + '-tab';
    		},
    		getTarget: function(year) {
    			return '#t' + year;
    		},
    		getTabId: function(year) {
    			return 't' + year;
    		},
    		getTabAreaLabel: function(year) {
    			return 't' + year + '-tab';
    		},
    		getFormattedDate: function(date) {
    			return DateEx.formatDate(date, 'dd.MM.yy', 'de');
    		},
    		getCalculatedPrice: function(price) {
    			if (!price || price <= 0) return '';
    			return (Number(price) / 100).toLocaleString('de-DE', {
    				minimumFractionDigits: 2
    			}) + ' €';
    		},
    		isDateInRange: function(fromdate, tilldate, year) {
    			if (!fromdate || !tilldate) return false;
    			const start = new Date(fromdate).getFullYear();
    			const end = new Date(tilldate).getFullYear();
    			return year >= start && year <= end;
    		}
    	}
    };
</script>